import React from 'react';

import Header from './sections/Header';
import Hero from './sections/Hero';
import Features from './sections/Features';
import Download from './sections/Download';
import Contact from './sections/Contact';
import Footer from './sections/Footer';
import FAQ from './sections/FAQ';

function App() {
  return (
    <>
      <Header />
      <Hero />
      <Features />
      <Download />
      <FAQ />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
